import React from 'react';
import { Link, Text, Container, Grid, Flex, Stack } from 'basis';
import styled from '@emotion/styled';
import { FooterLinkKey, FooterLinks } from './NzFooter';

import { NZFooterLogo } from 'components/logo/nz/NzGemLogo';

type Props = {
  trackEventSender: (label: string) => void;
  getLinkWithAnalytics: (key: FooterLinkKey) => string;
  footerLinks: FooterLinks;
};

export const FooterWrapper = styled.div`
  background-color: var(--Indigo-1000, #0b2374);
`;

const LinkWrapper = styled.div`
  span {
    color: white;
    text-decoration: underline;
  }

  span:hover {
    background: inherit;
  }
`;

export const DefaultFooter: React.FC<Props> = ({ trackEventSender, getLinkWithAnalytics, footerLinks }) => {
  return (
    <Container testId="nz-card-footer">
      <FooterWrapper>
        <Container padding="5 4" hasBreakpointWidth>
          <Container margin="auto" margin-md="auto">
            <Grid colsGutter="0" cols="6">
              <Grid.Item colSpan="0-1" colSpan-md="0" colSpan-lg="0" rowSpan="0" rowSpan-md="0" margin-md="0">
                <Container padding="6 0" padding-md="0 0 5 0">
                  <Flex placeItems="center left">
                    <NZFooterLogo />
                  </Flex>
                </Container>
              </Grid.Item>

              <Grid.Item colSpan="all">
                <Flex placeItems="left">
                  <Stack direction="horizontal" align="left" gap="3 4">
                    {Object.keys(footerLinks).map((k) => {
                      const key = k as FooterLinkKey;
                      return (
                        <LinkWrapper>
                          <Link
                            variant="medium-bg"
                            key={key}
                            href={getLinkWithAnalytics(key)}
                            newTab
                            onClick={() => trackEventSender(footerLinks[key].label)}
                          >
                            {footerLinks[key].label}
                          </Link>
                        </LinkWrapper>
                      );
                    })}
                  </Stack>
                </Flex>
              </Grid.Item>

              <Grid.Item colSpan="all">
                <Flex placeItems="left">
                  <Container textStyle="legal" margin="7 0 0 0">
                    <Text color="white">Gem Visa is provided by Latitude Financial Services Limited.</Text>
                  </Container>
                </Flex>
              </Grid.Item>
            </Grid>
          </Container>
        </Container>
      </FooterWrapper>
    </Container>
  );
};
